import React from 'react';
import ChatwootWidget from '../ChatwootWidget';
import FreshchatWidget from '../FreshchatWidget';

const ChatWidget = () => {
  const chatbot = process.env.REACT_APP_ACTIVATE_CHATBOT;

  if (chatbot === 'chatwoot') {
    return <ChatwootWidget />;
  }
  
  if (chatbot === 'freshchat') {
    return <FreshchatWidget />;
  }

  // If no chatbot is configured or invalid value, don't render anything
  return null;
};

export default ChatWidget;